import{_ as r}from"./_Symbol.js";var t=r,a=Object.prototype,o=a.hasOwnProperty,e=a.toString,v=t?t.toStringTag:void 0;var c=function(r){var t=o.call(r,v),a=r[v];try{r[v]=void 0;var c=!0}catch(r){}var i=e.call(r);return c&&(t?r[v]=a:delete r[v]),i};export{c as _};
//# sourceMappingURL=_getRawTag.js.map
